import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { withRouter, Switch, Route } from 'react-router-dom'
import DocumentTitle from 'react-document-title'
import PropTypes from 'prop-types'

import Scroll from '@components/Scroll'
import Spinner from '@components/spinner'
import Header from '@components/Details/Header'
import Tabs from '@components/Tabs'
import NotificationSettings from './NotificationSettings'
import { groupBy } from 'lodash'

class Settings extends Component {
  static propTypes = {
    notificationStore: PropTypes.object,
    match: PropTypes.object
  }

  componentDidMount () {
    const { notificationStore } = this.props
    if (!notificationStore.initNotificationTypes) {
      notificationStore.getNotificationTypes()
    }
  }

  render () {
    const { match, notificationStore } = this.props

    const {
      initNotificationTypes,
      notificationTypes,
      deliveryTypes
    } = notificationStore

    const tabs = [
      { tab: 'notifications' },
      { tab: 'epl-notifications' },
      { tab: 'email-notifications' }
    ]

    if (!initNotificationTypes) return <Spinner />
    return (
      <DocumentTitle title='Settings | Atheneum Partners'>
        <Scroll>
          <div className='expert-search'>
            <div className='project-wrapper email-templates-wrapper'>
              <Header>
                <div className='info info--noLeft'>
                  <div className='name-status-wrapper'>
                    <h1>Settings</h1>
                  </div>
                </div>
              </Header>
              <div className='expert-tabs'>
                <Tabs defaultTab='notifications' tabs={tabs} />
              </div>
              <div className='views-wrapper'>
                <Switch>
                  <Route
                    exact
                    path={match.url}
                    render={() => (
                      <NotificationSettings
                        notificationTypes={notificationTypes.notifications}
                        deliveryTypes={deliveryTypes}
                      />
                    )}
                  />
                  <Route
                    exact
                    path={`${match.url}/epl-notifications`}
                    render={() => (
                      <NotificationSettings
                        notificationTypes={notificationTypes.eplNotifications}
                        deliveryTypes={deliveryTypes}
                      />
                    )}
                  />
                  <Route
                    exact
                    path={`${match.url}/email-notifications`}
                    render={() => <NotificationSettings />}
                  />
                </Switch>
              </div>
            </div>
          </div>
        </Scroll>
      </DocumentTitle>
    )
  }
}

export default withRouter(inject('notificationStore')(observer(Settings)))
